import BaseApi from './baseApi';
import IAuthentication from '../models/IAuthentication';
import { StringObjectArrayListTuple, StringObjectTuple } from '../types/types';
import DataAcessApi from './DataAccessApi';
import IDataTable from '../models/IDataTable';
import { createDataAccessStore } from '@/store/stores/DataAcess-store';
import { IDossierCounter } from '../models/IDossierCounter';
import { IDossierOutbound } from '../models/IDossierOutbound';
import { IDossierInboundDeliveryNote } from '../models/IDossierInboundDeliveryNotes';
import { IDossierInboundDocument } from '../models/IDossierInboundDocument';
import { IDossierInboundNoticeOfLoss } from '../models/IDossierInboundNoticeOfLoss';
import { IDossierInboundPicture } from '../models/IDossierInboundPicture';
import { IDossierInbound } from '../models/IDossierInbound';
import { IDossierOutboundDeliveryNote } from '../models/IDossierOutboundDeliveryNotes';
import { IDossierOutboundDocument } from '../models/IDossierOutboundDocument';
import { IDossierOutboundNoticeOfLoss } from '../models/IDossierOutboundNoticeOfLoss';
import { IDossierOutboundPicture } from '../models/IDossierOutboundPicture';
import { IDossierMovements } from '../models/IDossierMovements';
export default class DossierApi extends BaseApi {
    idUser : string = "";
    dataAcess: any = null;

    constructor() {
        super("dataaccess", "Dossiers");
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idUser = userFromStorage.idPerson;
        this.dataAcess = createDataAccessStore('dataAcessListCitiesMain');
        this.dataAcess.FormId = "Inbounds";
    }

    async GetCounters(inboundCode: string) {
        let parameters : StringObjectTuple[];
        parameters = [['InboundCode', inboundCode]];
        const api = new DataAcessApi("Dossier1");
        try {
            let data: IDataTable = await api.ExecStructuredProcedure("DOSSIER_READ_COUNTERS", parameters, []);
            return this.MapToDossierCounters(data);
        } catch (error) {
            console.error('Error fetching fields:', error);
        }
        return [];
    }

    async GetMovements(inboundCode: string) {
        let parameters : StringObjectTuple[];
        parameters = [['InboundCode', inboundCode]];
        const api = new DataAcessApi("Dossier2");
        try {
            let data: IDataTable = await api.ExecStructuredProcedure("DOSSIER_READ_GOODS_MOVEMENTS", parameters, []);
            return this.MapToDossierMovements(data);
        } catch (error) {
            console.error('Error fetching fields:', error);
        }
        return [];
    }

    async DossierReadInbounds(inboundCode: string) {
        let parameters : StringObjectTuple[];
        parameters = [['InboundCode', inboundCode]];
        const api = new DataAcessApi("Dossier3");
        try {
            let data: IDataTable = await api.ExecStructuredProcedure("DOSSIER_READ_INBOUNDS", parameters, []);
            return this.MapToDossierInbounds(data);
        } catch (error) {
            console.error('Error fetching fields:', error);
        }
        return [];
    }

    async DossierReadInboundsDeliveryNotes(inboundCode: string) {
        let parameters : StringObjectTuple[];
        parameters = [['InboundCode', inboundCode]];
        const api = new DataAcessApi("Dossier4");
        try {
            let data: IDataTable = await api.ExecStructuredProcedure("DOSSIER_READ_INBOUNDS_DELIVERY_NOTES", parameters, []);
            return this.MapToDossierInboundDeliveryNotes(data);
        } catch (error) {
            console.error('Error fetching fields:', error);
        }
        return [];
    }

    async DossierReadInboundDocuments(inboundCode: string) {
        let parameters : StringObjectTuple[];
        parameters = [['InboundCode', inboundCode]];
        const api = new DataAcessApi("Dossier5");
        try {
            let data: IDataTable = await api.ExecStructuredProcedure("DOSSIER_READ_INBOUNDS_DOCUMENTS", parameters, []);
            return this.MapToDossierInboundDocuments(data);
        } catch (error) {
            console.error('Error fetching fields:', error);
        }
        return [];
    }

    async DossierReadInboundNoticeOfLoss(inboundCode: string) {
        let parameters : StringObjectTuple[];
        parameters = [['InboundCode', inboundCode]];
        const api = new DataAcessApi("Dossier6");
        try {
            let data: IDataTable = await api.ExecStructuredProcedure("DOSSIER_READ_INBOUNDS_NOTICE_OF_LOSS", parameters, []);
            return this.MapToDossierInboundNoticeOfLoss(data);
        } catch (error) {
            console.error('Error fetching fields:', error);
        }
        return [];
    }

    async DossierReadInboundPictures(inboundCode: string) {
        let parameters : StringObjectTuple[];
        parameters = [['InboundCode', inboundCode]];
        const api = new DataAcessApi("Dossier7");
        try {
            let data: IDataTable = await api.ExecStructuredProcedure("DOSSIER_READ_INBOUNDS_PICTURES", parameters, []);
            return this.MapToDossierInboundPictures(data);
        } catch (error) {
            console.error('Error fetching fields:', error);
        }
        return [];
    }

    async DossierReadOutbounds(inboundCode: string) {
        let parameters : StringObjectTuple[];
        parameters = [['InboundCode', inboundCode]];
        const api = new DataAcessApi("Dossier8");
        try {
            let data: IDataTable = await api.ExecStructuredProcedure("DOSSIER_READ_OUTBOUNDS", parameters, []);
            return this.MapToDossierOutbounds(data);
        } catch (error) {
            console.error('Error fetching fields:', error);
        }
        return [];
    }

    async DossierReadOutboundsDocuments(inboundCode: string) {
        let parameters : StringObjectTuple[];
        parameters = [['InboundCode', inboundCode]];
        const api = new DataAcessApi("Dossier9");
        try {
            let data: IDataTable = await api.ExecStructuredProcedure("DOSSIER_READ_OUTBOUNDS_DOCUMENTS", parameters, []);
            return this.MapToDossierOutboundDocuments(data);
        } catch (error) {
            console.error('Error fetching fields:', error);
        }
        return [];
    }

    async DossierReadOutboundsPictures(inboundCode: string) {
        let parameters : StringObjectTuple[];
        parameters = [['InboundCode', inboundCode]];
        const api = new DataAcessApi("Dossier10");
        try {
            let data: IDataTable = await api.ExecStructuredProcedure("DOSSIER_READ_OUTBOUNDS_PICTURES", parameters, []);
            return this.MapToDossierOutboundPictures(data);
        } catch (error) {
            console.error('Error fetching fields:', error);
        }
        return [];
    }

    async DossierReadOutboundsNoticeOfLoss(inboundCode: string) {
        let parameters : StringObjectTuple[];
        parameters = [['InboundCode', inboundCode]];
        const api = new DataAcessApi("Dossier11");
        try {
            let data: IDataTable = await api.ExecStructuredProcedure("DOSSIER_READ_OUTBOUNDS_NOTICE_OF_LOSS", parameters, []);
            return this.MapToDossierOutboundNoticeOfLoss(data);
        } catch (error) {
            console.error('Error fetching fields:', error);
        }
        return [];
    }

    async DossierReadOutboundsDeliveryNotes(inboundCode: string) {
        let parameters : StringObjectTuple[];
        parameters = [['InboundCode', inboundCode]];
        const api = new DataAcessApi("Dossier12");
        try {
            let data: IDataTable = await api.ExecStructuredProcedure("DOSSIER_READ_OUTBOUNDS_DELIVERY_NOTES", parameters, []);
            return this.MapToDossierOutboundDeliveryNotes(data);
        } catch (error) {
            console.error('Error fetching fields:', error);
        }
        return [];
    }

    MapToDossierCounters(data: IDataTable): IDossierCounter[] {
        if (!data || !data.records || !data.columns) {
            throw new Error("Invalid data format: Missing records or columns");
        }

        return data.records.map(record => {
            return {
                type: record.type || "",
                counter: record.counter || 0
            };
        });
    }

    MapToDossierMovements(data: IDataTable): IDossierMovements[] {
        if (!data || !data.records || !data.columns) {
            throw new Error("Invalid data format: Missing records or columns");
        }

        return data.records.map((record: any) => {
            return {
                id: record.id || "",
                code: record.code || "",
                companySource: record.companySource || "",
                warehouseSource: record.warehouseSource || "",
                companyDestination: record.companyDestination || "",
                warehouseDestination: record.warehouseDestination || "",
                date: record.date ? new Date(record.date) : new Date(0),
                idGoodsMovement: record.idGoodsMovement || "",
                goodName: record.goodName || "",
                palletType: record.palletType || "",
                idPallet: record.idPallet || "",
                casesPerPallet: record.casesPerPallet || 0,
                goodsPerCase: record.goodsPerCase || 0,
                totalGoods: record.totalGoods || 0
            } as IDossierMovements;
        });
    }

    MapToDossierInbounds(data: IDataTable): IDossierInbound[] {
        if (!data || !data.records || !data.columns) {
            throw new Error("Invalid data format: Missing records or columns");
        }

        return data.records.map((record: any) => {
            return {
                // --- Campos de Inbounds ---
                id: record.id || "",
                idCompanySource: record.idCompanySource || "",
                companySourceName: record.companySourceName || "",
                idCompanyDestination: record.idCompanyDestination || "",
                companyDestinationName: record.companyDestinationName || "",
                idCustomer: record.idCustomer || "",
                customerName: record.customerName || "",
                idStatus: record.idStatus || "",
                statusName: record.statusName || "",
                code: record.code || "",
                dateIn: record.dateIn ? new Date(record.dateIn) : null,
                description: record.description || "",
                containerNumber: record.containerNumber || "",
                sealNumber: record.sealNumber || "",
                weight: record.weight || 0,
                liters: record.liters || 0,
                referenceInboundCode: record.referenceInboundCode || "",
                orderNumber: record.orderNumber || "",
                startTime: record.startTime || 0,
                endTime: record.endTime || 0,
                dateChanged: record.dateChanged === true || record.dateChanged === 1,
                totalValue: record.totalValue || 0,
                agp: record.agp || "",
                arrivalFrom: record.arrivalFrom || "",
                codeDestination: record.codeDestination || "",
                idListTypesInbounds: record.idListTypesInbounds || "",
                listTypesInboundsName: record.listTypesInboundsName || "",
                idListCurrency: record.idListCurrency || "",
                listCurrencyName: record.listCurrencyName || "",

                // --- Campos de InboundsDetail ---
                idInbound: record.idInbound || "",
                idGood: record.idGood || "",
                goodName: record.goodName || "",
                sku: record.sku || "",
                idListPallet: record.idListPallet || "",
                palletName: record.palletType || "",
                palletsAmount: record.palletsAmount || 0,
                casesPerPallet: record.casesPerPallet || 0,
                totalCases: record.totalCases || 0,
                goodsPerCase: record.goodsPerCase || 0,
                totalGoods: record.totalGoods || 0,
                bestBeforeDate: record.bestBeforeDate ? new Date(record.bestBeforeDate) : null,
                inDeliveryNote: record.inDeliveryNote || 0,
                language: record.language || "",
                documentation: record.documentation === true || record.Documentation === 1,
                casesLoss: record.casesLoss || 0,

                // --- Campos adicionales del SELECT ---
                GoodName: record.goodName || null,
                PalletType: record.palletType || null,
                CompanySource: record.companySource || null,
                CompanyDestination: record.companyDestination || null,
                Customer: record.customer || null,
                Status: record.status || null,
                InboundType: record.inboundType || null
            } as IDossierInbound;
        });
    }

    MapToDossierInboundDeliveryNotes(data: IDataTable): IDossierInboundDeliveryNote[] {
        if (!data || !data.records || !data.columns) {
            throw new Error("Invalid data format: Missing records or columns");
        }

        return data.records.map((record: any) => {
            return {
                // --- Campos de InboundsDeliveryNotes ---
                id: record.id || "",
                idInbound: record.idInbound || "",
                inboundCode: record.inboundCode || "",
                idCompanySource: record.idCompanySource || "",
                companySourceName: record.companySourceName || "",
                idCompanyDestination: record.idCompanyDestination || "",
                companyDestinationName: record.companyDestinationName || "",
                idWarehouse: record.idWarehouse || "",
                warehouseName: record.warehouseName || "",
                idCustomer: record.idCustomer || "",
                customerName: record.customerName || "",
                code: record.code || "",
                dateIn: record.dateIn ? new Date(record.dateIn) : null,
                description: record.description || "",
                idStatus: record.idStatus || "",
                statusName: record.statusName || "",
                codeSource: record.codeSource || "",
                codeDestination: record.codeDestination || "",
                idDock: record.idDock || "",
                dockName: record.dockName || "",
                dockPicked: record.dockPicked === true || record.dockPicked === 1,

                // --- Campos de InboundsDeliveryNotesDetail ---
                idInboundDeliveryNote: record.idInboundDeliveryNote || "",
                idInboundDetail: record.idInboundDetail || "",
                idGood: record.idGood || "",
                goodName: record.goodName || "",
                idListPallet: record.idListPallet || "",
                palletName: record.palletType || "",
                palletsAmount: record.palletsAmount || 0,
                casesPerPallet: record.casesPerPallet || 0,
                totalCases: record.totalCases || 0,
                goodsPerCase: record.goodsPerCase || 0,
                totalGoods: record.totalGoods || 0,
                location: record.location || "",
                weight: record.weight || 0,
                bestBeforeDate: record.bestBeforeDate ? new Date(record.bestBeforeDate) : null,
                idPallet: record.idPallet || "",
                casesLoss: record.casesLoss || 0,
                language: record.language || "",

                // --- Campos adicionales del SELECT ---
                CompanySource: record.companySourceName || null,
                CompanyDestination: record.companyDestinationName || null,
                Warehouse: record.warehouse || null,
                Customer: record.customer || null,
                Status: record.status || null,
                GoodName: record.goodName || null,
                PalletType: record.palletType || null
            } as IDossierInboundDeliveryNote;
        });
    }
    
    MapToDossierInboundDocuments(data: IDataTable): IDossierInboundDocument[] {
        if (!data || !data.records || !data.columns) {
            throw new Error("Invalid data format: Missing records or columns");
        }

        return data.records.map((record: any) => {
            return {
                id: record.id || "",
                idListCustomPaper: record.idListCustomPaper || "",
                custompapername: record.customPaper || "",
                description: record.description || "",
                url: record.url || "",
                idCompany: record.idCompany || "",
                idInbound: record.idInbound || ""
            } as IDossierInboundDocument;
        });
    }
    MapToDossierInboundNoticeOfLoss(data: IDataTable): IDossierInboundNoticeOfLoss[] {
        if (!data || !data.records || !data.columns) {
            throw new Error("Invalid data format: Missing records or columns");
        }
        
        return data.records.map((record: any) => {
            return {
                // --- Campos de InboundsNoticeOfLoss ---
                id: record.Id || "",
                idDeliveryNote: record.idInboundDeliveryNote || "",
                idWarehouse: record.idWarehouse || "",
                warehouseName: record.warehouse || "",
                date: record.date ? new Date(record.date) : null,
                description: record.description || "",

                // --- Campos de InboundsNoticeOfLossDetail ---
                idNoticeOfLoss: record.idNoticeOfLoss || "",
                idDeliveryNoteDetail: record.idInboundDeliveryNoteDetail || "",
                idListPallet: record.idListPallet || "",
                listPalletName: record.palletType || "",
                idPallet: record.idPallet || "",
                casesPerPallet: record.casesPerPallet || 0,
                goodsPerCase: record.goodsPerCase || 0,
                totalGoods: record.totalGoods || 0,

                // --- Campos adicionales del SELECT ---
                Warehouse: record.warehouse || null,
                PalletType: record.palletType || null
            } as IDossierInboundNoticeOfLoss;
        });
    }

    MapToDossierInboundPictures(data: IDataTable): IDossierInboundPicture[] {
        if (!data || !data.records || !data.columns) {
            throw new Error("Invalid data format: Missing records or columns");
        }

        return data.records.map((record: any) => {
            return {
                id: record.id || "",
                idInbound: record.idInbound || "",
                url: record.url || "",
                idCompany: record.idCompany || "",
                urlBlob: record.urlBlob || ""
            } as IDossierInboundPicture;
        }
        );
    }
    MapToDossierOutbounds(data: IDataTable): IDossierOutbound[] {
        if (!data || !data.records || !data.columns) {
            throw new Error("Invalid data format: Missing records or columns");
        }

        return data.records.map((record: any) => ({
            // --- Campos del header (Outbounds) ---
            id: record.id || "",
            idCompanyDestination: record.idCompanyDestination || "",
            idCompanySource: record.idCompanySource || "",
            idCustomer: record.idCustomer || "",
            companySourceName: record.companySource || "",
            companyDestinationName: record.companyDestination || "",
            customerName: record.customer || "",
            customerDestination: record.customerDestination || "",
            code: record.code || "",
            dateOut: record.dateOut ? new Date(record.dateOut) : new Date(0),
            weight: record.weight || null,
            liters: record.liters || null,
            containerNumber: record.containerNumber || "",
            sealNumber: record.sealNumber || "",
            orderNumber: record.orderNumber || "",

            // --- Campos del detail (OutboundsDetail) ---
            idOutbound: record.idOutbound || "",
            codeInbound: record.codeInbound || "",
            goodName: record.goodName || "",
            totalCases: record.totalCases || 0,
            goodsPerCase: record.goodsPerCase || 0,
            totalGoods: record.totalGoods || 0,
            bestBeforeDate: record.BestBeforeDate ? new Date(record.BestBeforeDate) : new Date(0),
            weightDetail: record.weight || null,
            litersDetail: record.liters || null,
            totalValue: record.totalValue || 0,

            // --- Campos adicionales del SELECT ---
            CompanySource: record.companySource || null,
            CompanyDestination: record.companyDestination || null,
            Customer: record.customer || null,
            Status: record.status || null,
            GoodName: record.goodName || null
        }));
    }
    MapToDossierOutboundDeliveryNotes(data: IDataTable): IDossierOutboundDeliveryNote[] {
        if (!data || !data.records || !data.columns) {
            throw new Error("Invalid data format: Missing records or columns");
        }

        return data.records.map((record: any) => {
            return {
                // --- Campos de OutboundsDeliveryNotes ---
                id: record.Id || "",
                idCompanyDestination: record.idCompanyDestination || "",
                idCompanySource: record.idCompanySource || "",
                idCustomer: record.idCustomer || "",
                companySource: record.companySource || "",
                companyDestination: record.companyDestination || "",
                warehouseName: record.warehouseName || "",
                customer: record.customer || "",
                code: record.code || "",
                dateOut: record.dateOut ? new Date(record.dateOut) : null,

                // --- Campos de OutboundsDeliveryNotesDetail ---
                idOutboundDeliveryNote: record.idOutboundDeliveryNote || "",
                goodName: record.goodName || "",
                palletType: record.palletType || "",
                casesPerPallet: record.casesPerPallet || 0,
                totalCases: record.totalCases || 0,
                goodsPerCase: record.goodsPerCase || 0,
                totalGoods: record.totalGoods || 0,
                weight: record.weight || 0,
                bestBeforeDate: record.bestBeforeDate ? new Date(record.bestBeforeDate) : null,
                idPallet: record.idPallet || ""
            } as IDossierOutboundDeliveryNote;
        });
    }
    MapToDossierOutboundDocuments(data: IDataTable): IDossierOutboundDocument[] {
        if (!data || !data.records || !data.columns) {
            throw new Error("Invalid data format: Missing records or columns");
        }

        return data.records.map((record: any) => {
            return {
                id: record.id || "",
                idListCustomPaper: record.idListCustomPaper || "",
                custompapername: record.customPaper || "",
                description: record.description || "",
                url: record.url || "",
                idCompany: record.idCompany || "",
                idOutbound: record.idOutbound || "",
                CustomPaper: record.customPaper || null
            } as IDossierOutboundDocument;
        });
    }
    MapToDossierOutboundNoticeOfLoss(data: IDataTable): IDossierOutboundNoticeOfLoss[] {
        if (!data || !data.records || !data.columns) {
            throw new Error("Invalid data format: Missing records or columns");
        }

        return data.records.map((record: any) => {
            return {
                id: record.id || "",
                idDeliveryNote: record.idDeliveryNote || "",
                warehouse: record.warehouse || "",
                date: record.date ? new Date(record.date) : null,
                idNoticeOfLoss: record.idNoticeOfLoss || "",
                idDeliveryNoteDetail: record.idDeliveryNoteDetail || "",
                palletType: record.palletType || "",
                idPallet: record.idPallet || "",
                casesPerPallet: record.casesPerPallet || 0,
                goodsPerCase: record.goodsPerCase || 0,
                totalGoods: record.totalGoods || 0
            } as IDossierOutboundNoticeOfLoss;
        });
    }

    MapToDossierOutboundPictures(data: IDataTable): IDossierOutboundPicture[] {
        if (!data || !data.records || !data.columns) {
            throw new Error("Invalid data format: Missing records or columns");
        }

        return data.records.map((record: any) => {
            return {
                id: record.id || "",
                idOutbound: record.idOutbound || "",
                url: record.url || "",
                idCompany: record.idCompany || "",
                urlBlob: record.urlBlob || ""
            } as IDossierOutboundPicture;
        });
    }
}
